<template>
     <div class="opera-accountLocker">
         <topNav :title="$t('account_lockerTip')" url="/opera/account"></topNav>
         <div class="whiteBox ">
              <a class="mint-cell">
                <div class="mint-cell-left"></div>
                <div class="mint-cell-wrapper">
                    <div class="mint-cell-title">
                        <span class="mint-cell-text">{{$t('accountLocker_1')}}</span>
                    </div>
                  <mt-switch v-model="locker" @change='changeSet'></mt-switch>
                </div>
                <div class="mint-cell-right"></div>
            </a>
              <a class="mint-cell" v-if="locker">
                <div class="mint-cell-left"></div>
                <div class="mint-cell-wrapper" @click="changeLocker">
                    <div class="mint-cell-title">
                        <span class="mint-cell-text">{{$t('accountLocker_2')}}</span>
                    </div>
                <i class="mint-cell-allow-right"></i>
                </div>
                <div class="mint-cell-right"></div>
            </a>
      </div>
      <div class="tip">
        {{$t('accountLocker_tip')}}
      </div>
     </div>
</template>
<script>
import { Switch,MessageBox } from "mint-ui";
export default {
  data() {
    return {
      locker: true,
      lockerset:true,
    };
  },
  mounted() {
    var store = this.$isApp?plus.storage:localStorage;
    if(store.getItem("accountlocker") != null && store.getItem("accountlocker") == "2"){
      this.locker = false;
      this.lockerset = false;

    }
   var that = this;
    window.lback = function(){
        that.lockerset = false;
        that.locker = false;
    }
  },
  methods: {
    changeSet(){
        var store = this.$isApp?plus.storage:localStorage;
        var that = this;
        if(this.lockerset){
            //2禁用
            store.setItem("accountlocker","2");
            that.lockerset = false;
            store.removeItem("password");
        }
        else{
          this.lockerset = true;
          //1启用
          store.setItem("accountlocker","1");
          var A = plus.webview.getLaunchWebview();
          A.evalJS('modifyGesturePwd(true)');
      }
    },
    changeLocker() {
        var A = plus.webview.getLaunchWebview();
         A.evalJS('modifyGesturePwd(false)');
    }
  }
};
</script>
<style lang='less'>
.opera-accountLocker {
  background-color: #f7f8fa;
  .whiteBox {
    width: 100%;
    margin-top: 0.5333rem;
    height: auto;
    background-color: #fff;
  }
  .tipBox {
    width: 93.5%;
    color: #999;
    height: 0.8rem;
    line-height: 0.8rem;
    margin: 0 auto;
    font-size: 0.37rem;
  }
  .mint-switch-input:checked + .mint-switch-core {
    border-color: #1faa1d;
    background-color: #1faa1d;
  }
  .tip {
    width: 96%;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.34rem;
    margin-left: 0.2rem;
    color:#c0c0c0;
  }
}
</style>



// WEBPACK FOOTER //
// accountLocker.vue?866d97ba